import {FC, RefObject} from 'react';
import {MenuButton, QuickMenu, Svg} from 'ui-kit';
import {Box, Flex} from '@chakra-ui/react';
import {
  authStart,
  EOAuthFlowType,
  EOAuthType,
  hasValue,
  IIntegration,
  IServiceStart,
  OAUTH_ICONS,
  useT
} from '@kcast-fe/core';

interface IProps {
  hasAccount: boolean;
  ref: RefObject<HTMLElement | null>;
  integrations: IIntegration[];
  onOpenCredentialsForm: (type: EOAuthType) => void;
}

export const NewAccountMenu: FC<IProps> = ({
  integrations,
  ref,
  hasAccount,
  onOpenCredentialsForm
}) => {
  const {t} = useT();

  const handleAuthStart = async (service: EOAuthType) => {
    const integration = integrations.find((i) => i.service === service);

    if (integration?.auth_flow === EOAuthFlowType.OAuthRedirect) {
      const response: IServiceStart = await authStart(service);
      if (hasValue(response?.auth_url)) {
        document.location = response.auth_url;
      }
    }

    if (integration?.auth_flow === EOAuthFlowType.CredentialsForm) {
      onOpenCredentialsForm(service);
    }
  };

  return (
    <Box>
      {hasAccount ? (
        <QuickMenu
          hideActive
          container={ref}
          placement={'bottom-start'}
          trigger={
            <Flex gap={'6px'} alignItems={'center'} color={'{colors.textLink}'} cursor={'pointer'}>
              <Svg name={'Plus'} size={'s24'} />
              <Box>{t('actions.addConnection')}</Box>
            </Flex>
          }
          items={integrations.map((i) => ({
            id: i.service,
            icon: OAUTH_ICONS[i.service],
            name: t(`enums.oauthType.${i.service}`),
            onClick: () => {
              handleAuthStart(i.service).then();
            }
          }))}
        />
      ) : (
        <MenuButton
          isFullWidth
          isHiddenArrow
          container={ref}
          label={t('actions.addConnection')}
          items={integrations.map((i) => ({
            icon: OAUTH_ICONS[i.service],
            label: t(`enums.oauthType.${i.service}`),
            onClick: () => {
              handleAuthStart(i.service).then();
            }
          }))}
        />
      )}
    </Box>
  );
};
